






































// vue
import { Component, Vue } from 'vue-property-decorator'

// componnents
import { PageHeader } from '@/components'
import { TableListReasonForPermission } from '@/components/config'

// services
import { ReasonForPermissionService } from '@/services/config'

// utils
import { loading, alerts } from '@/utils'

// models
import { ReasonForPermissionForm, ReasonForPermissionModel } from '@/models/config'
import { BvModalEvent } from 'bootstrap-vue'

// views
import ModalCreateEditReasonForPermission from './modalCreateEdit.vue'

const newItem: ReasonForPermissionForm = {
  description: '',
  abbreviated: '',
  type: '',
  has_subsidy: false,
  apply_sunday_discount: false,
  is_active: true
}

@Component({
  name: 'ReasonForPermissionIndex',
  components: {
    PageHeader,
    TableListReasonForPermission,
    ModalCreateEditReasonForPermission
  }
})
export default class ReasonForPermissionIndex extends Vue {
  showModal = false
  reason: ReasonForPermissionForm = newItem
  title = 'Motivos de Permisos'
  actionForm = 'save'
  idItemEdit: number|null = null
  items = [
    {
      text: 'Dashboard'
    },
    {
      text: 'Motivos de Permisos',
      active: true
    }
  ]

  hideModal (event: BvModalEvent) {
    if (event.trigger !== 'ok') {
      this.showModal = false
    }
  }

  addNew () {
    this.idItemEdit = null
    this.actionForm = 'save'
    this.reason = newItem
    this.showModal = true
  }

  editItem (item: ReasonForPermissionModel) {
    this.reason = {
      description: item.description,
      abbreviated: item.abbreviated,
      is_active: item.is_active,
      type: item.type,
      has_subsidy: item.has_subsidy,
      apply_sunday_discount: item.apply_sunday_discount
    }
    if (item.id) {
      this.idItemEdit = Number(item.id)
    }
    this.actionForm = 'update'
    this.showModal = true
  }

  async deleteItem (item: ReasonForPermissionModel) {
    const msg = 'Seguro que desea eliminar el Motivo de Permiso seleccionado'
    const confirm = await alerts.confirm(msg)
    if (confirm && item.id) {
      loading('show')
      await ReasonForPermissionService.delete(item.id)
      alerts.success()
      this.tableList.getreasonsWithPagination()
      loading('hide')
    }
  }

  async changeStatus (info: {id: number; status: boolean}) {
    loading('show')
    try {
      await ReasonForPermissionService.changeStatus(info.id, info.status)
      alerts.success()
      this.tableList.getreasonsWithPagination()
    } catch (e) {
      alerts.error()
    }
    loading('hide')
  }

  get tableList (): Vue & { getreasonsWithPagination: () => void } {
    return this.$refs.table_list as Vue & { getreasonsWithPagination: () => void }
  }

  get itemInit (): ReasonForPermissionForm {
      return newItem
  }
}
